import { useEffect, useReducer } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const RETAIL_BASE = `${BACKEND_URL}/api/retail/public`;

const initial = { loading: true, gateError: null, catalogData: null };

function reducer(state, action) {
  switch (action.type) {
    case "loading":      return { ...state, loading: true };
    case "loaded":       return { loading: false, gateError: null, catalogData: action.data };
    case "gate-error":   return { loading: false, gateError: action.message, catalogData: null };
    default:             return state;
  }
}

// Phase 3M — extracted from RetailCustomer.jsx. Identical behaviour:
// 403 → operator-facing gate message, 404 → shop-not-found, other →
// generic retry message. Returns `{ loading, gateError, catalogData }`.
// Internally uses useReducer so the lint rule react-hooks/set-state-in-effect
// stays satisfied (single dispatch instead of multiple setStates).
// Phase 3L.6 — accepts an optional `linkSlug` for the new
// /retail/{tenant}/{link_slug} route; forwarded as ?link_slug=… so the
// public resolver picks the matching link profile's catalog.
export default function useRetailCatalog(slug, linkSlug) {
  const [state, dispatch] = useReducer(reducer, initial);

  useEffect(() => {
    let alive = true;
    dispatch({ type: "loading" });
    const params = linkSlug ? `?link_slug=${encodeURIComponent(linkSlug)}` : "";
    axios.get(`${RETAIL_BASE}/${slug}/catalog${params}`)
      .then((r) => { if (alive) dispatch({ type: "loaded", data: r.data }); })
      .catch((e) => {
        if (!alive) return;
        const status = e?.response?.status;
        const detail = e?.response?.data?.detail;
        let message;
        if (status === 403) message = typeof detail === "string" ? detail : "Retail experience is not enabled for this business.";
        else if (status === 404) message = "We couldn't find this storefront. Please double-check the link.";
        else message = "We're having trouble loading the products. Please try again shortly.";
        dispatch({ type: "gate-error", message });
      });
    return () => { alive = false; };
  }, [slug, linkSlug]);

  return state;
}
